import { render, staticRenderFns } from "./CustomerModifyModal.vue?vue&type=template&id=17be5dc4&scoped=true"
import script from "./CustomerModifyModal.vue?vue&type=script&lang=js"
export * from "./CustomerModifyModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerModifyModal.vue?vue&type=style&index=0&id=17be5dc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be5dc4",
  null
  
)

export default component.exports